import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSupportedLanguages } from 'src/app/core/languages-support/i18n-config.service';
import { I18nModule } from 'src/app/core/languages-support/i18n.module';
import { AutoCompleteFormFieldModule } from 'src/app/libs/ui/components/auto-complete-form-field/auto-complete-form-field.module';
import { ButtonModule } from 'src/app/libs/ui/components/button/button.module';
import { DateRangeModule } from 'src/app/libs/ui/components/date-range/date-range.module';
import { AdultsChildrenAgeModule } from '../../components/adults-children-age/adults-children-age.module';
import { FindTripFormComponent } from './find-trip-form.component';

@NgModule({
  declarations: [
    FindTripFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteFormFieldModule,
    DateRangeModule,
    ButtonModule,
    I18nModule.forRoot(AppSupportedLanguages),
    AdultsChildrenAgeModule,
  ],
  exports: [
    FindTripFormComponent,
  ],
})
export class FindTripFormModule { }
